(function researchareaScript($, Drupal) {
  Drupal.behaviors.researcharea = {
    attach(context) {
      var $pill = $(".pill");
      var $pillFirst = $(".pill--first");
      var $pillSecond = $(".pill--second");
      var $relatedContentFirst = $(".related-content--first");
      var $relatedContentSecond = $(".related-content--second");

      $pill.click(function(e) {
        e.preventDefault();
      });

      $pillFirst.click(function() {
        $relatedContentFirst.show();
        $relatedContentSecond.hide();
        $(this).addClass("pill--active");
        $(this)
          .siblings()
          .removeClass("pill--active");
      });

      $pillSecond.click(function() {
        $relatedContentSecond.show();
        $relatedContentFirst.hide();
        $(this).addClass("pill--active");
        $(this)
          .siblings()
          .removeClass("pill--active");
      });
    }
  };
})(jQuery, Drupal);
